import React from 'react';
import { TrendingDown, CheckCircle, Zap } from 'lucide-react';
import { gsmGuide } from '../data/mockData';

const GSMGuide = () => {
    const badgeColors = [
        'from-primary to-primary/80',   // Primary teal
        'from-primary to-primary/80',   // Primary teal
        'from-primary to-primary/80'    // Primary teal
    ];

    return (
        <section id="gsm-guide" className="py-16 bg-gradient-to-br from-primary/5 via-white to-accent/5 relative overflow-hidden">
            {/* Decorative Elements */}
            <div className="absolute top-0 left-0 w-64 h-64 bg-primary/10 rounded-full -translate-y-1/2 -translate-x-1/2"></div>

            <div className="container mx-auto px-4 relative z-10">
                {/* Section Header - Marketing Focused */}
                <div className="text-center mb-12">
                    <div className="flex items-center justify-center gap-3 mb-4">
                        <Zap size={32} className="text-accent" />
                        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
                            Get the <span className="text-primary">Perfect Fabric Weight</span> Every Time
                        </h2>
                    </div>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Save money and boost quality by choosing the right GSM for your products. We stock all popular weights at wholesale prices.
                    </p>
                </div>

                {/* GSM Ranges Grid - Sales Focused */}
                <div className="grid md:grid-cols-3 gap-8 mb-8">
                    {gsmGuide.ranges.map((range, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-primary group"
                        >
                            <div className="text-center mb-6">
                                <div className={`inline-block bg-gradient-to-br ${badgeColors[index]} rounded-full px-6 py-3 mb-4`}>
                                    <h3 className="text-2xl font-bold text-white">{range.gsm}</h3>
                                </div>
                                <h4 className="text-xl font-semibold text-gray-900 mb-2">{range.name}</h4>
                                <p className="text-sm text-primary font-medium">Wholesale Price Available</p>
                            </div>

                            <div className="space-y-4">
                                <div>
                                    <p className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                                        <CheckCircle size={16} className="text-accent" />
                                        Perfect For:
                                    </p>
                                    <p className="text-gray-600">{range.uses}</p>
                                </div>

                                <div>
                                    <p className="text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
                                        <TrendingDown size={16} className="text-primary" />
                                        Our Stock:
                                    </p>
                                    <p className="text-gray-600">{range.fabrics}</p>
                                </div>
                            </div>

                            <div className="mt-6 pt-6 border-t border-gray-200">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2 text-primary">
                                        <CheckCircle size={18} />
                                        <span className="text-sm font-medium">In Stock Now</span>
                                    </div>
                                    <span className="text-xs text-gray-500 group-hover:text-primary transition-colors">All Colors</span>
                                </div>
                            </div>

                            {/* Hidden SEO Keywords - Properly Hidden */}
                            <span className="hidden">{range.keywords}</span>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default GSMGuide;
